import { ImageParams } from 'components/Common/ResponsiveImage'
import ImageGallery from 'components/Luxkit/Carousel/ImageGallery'
import React from 'react'

interface Props {
  imageProps?: ImageParams;
  className?: string;
  open?: boolean;
  onClose?: () => void;
  room: App.PackageRoomType | App.BedbankPackage;
  topRight?: React.ReactNode;
}

function OfferPageRoomGallery(props: Props) {
  const {
    className,
    imageProps,
    room,
    topRight,
  } = props

  return <ImageGallery
    className={className}
    images={room.images}
    imageParams={imageProps}
    size="small"
    showImageTitles={false}
    topRight={topRight}
  />
}

export default OfferPageRoomGallery
